import { request } from '@koi-design/vix-tools';
import store from '@/store';

const getBillingApiKey = () =>
  localStorage.getItem('billingApiKey') ||
  store.getters.botUserInfo?.api_key ||
  '';

const getBillingParams = params => ({
  ...params,
  api_key: params?.api_key || getBillingApiKey()
});

export const getPointsSummaryApi = params =>
  request({
    url: '/api/business/v1/wallet/points-summary',
    method: 'get',
    params: getBillingParams(params)
  });

export const getPointsConsumptionDetailsApi = params =>
  request({
    url: '/api/business/v1/wallet/points-consumption-details',
    method: 'get',
    params: getBillingParams(params)
  });
